import logger from 'logger';
import type { Lead } from '@backend/src/interfaces/mongoose.gen';
import type { CloseLocations, LocationApiLocation } from 'lib/locations';

/**
 * Determines if a given location is valid for a move
 *
 * @param locationID - ID of the location to check
 * @param closeLocations - Array of locations close to the move origin
 * @param currentLocationServiceArea - Service area of the currently selected location
 * @returns True if the location is valid for the move, false if not
 */
export const checkIfLocationIsOK = ({
  locationID,
  closeLocations,
  currentLocationServiceArea,
}: {
  locationID: Lead['locationID'];
  closeLocations: CloseLocations;
  currentLocationServiceArea: LocationApiLocation['serviceArea'];
}): boolean => {
  const allowedDistance = parseInt(
    currentLocationServiceArea?.distance || '30',
    10,
  );
  const foundLocation = closeLocations.find(
    (closeLocation) => closeLocation.location?.id === locationID?.toString(),
  );
  const locationOK =
    typeof locationID === 'number' &&
    typeof foundLocation !== 'undefined' &&
    (foundLocation.distance || 0) <= allowedDistance;

  logger.info('checkIfLocationIsOK', {
    locationID,
    closeLocations,
    currentLocationServiceArea,
    locationOK,
  });

  return locationOK;
};

export default checkIfLocationIsOK;
